import CostComponent from "../CostComponent";

/**
 * @type {import("../types").DialogStep}
*/
export const CostStep = (t, connection) => ({
    label: t("marketplace.costosAsociados"),
    inputs: [
        {
            component: "info",
            notInReview: true,
            content: () => {
                return (
                    <CostComponent connection={connection} />
                );
            }
        },
    ]
});
